
import {fetchingAssetsCategoryApi, inventoryListTypeAPI, fetchingAssetsInventoryName} from '@/api/room.js'
export const roomInventory = {
  data () {
    return {
      deletedFile:null,
      name:'',
      assets_types:'',
      asset_details:'',
      price:'',
      inventory_type:null,
      quantity:null,
      suitable_for:[],
      suitable:'',
      files:[],
      price_type:0,
      asset_codes:'',
      inventoryNameList: [],
      inventoryOptions:[
        {
          id:0,
          name:'Removable'
        },
        {
          id:1,
          name:'Non Removable'
        }
          
      ],

      booking_time_array:[
        {
          id:1,
          name:'Days'
        
        },
        {
          id:2,
          name:'Hour'
        
        },
        {
          id:3,
          name:'Month'
        
        }
      ],
      /*   assets_id:[],
      editingObject:{} */
      //assets category/
      categoryAssetPopUp:false,
      category_name:'',
      categoryList:[],
      inventoryTypeList:[], //for Room Creation
      non_removable_inventory_list:[],
      number_of_person:'',
      oldImages:[]

     
      //assets category//
    }
  },
  methods:{
    handleCloseSidebar () {
      this.$emit('closeSidebar', false)
    },
    addTags () {
      this.suitable_for.push(
        this.suitable
      )
      this.suitable = ''
    },
    /*   deleteFile (id, index) {
      const fileIndex = this.files.findIndex(ele => ele.files_id === id)
      this.files.splice(fileIndex, 1)
      this.oldImages.splice(index, 1)
      // 
      // 
    }, */
    deleteFile (index, fileObject) {
      /*  const fileIndex = this.files.findIndex(ele => ele.files_id === id)
      this.files.splice(fileIndex, 1)
      this.oldImages.splice(index, 1) */

      this.files.splice(index, 1)
      this.deletedFile = fileObject
      // 
      // 
    },
    deleteTag (index) {
      this.suitable_for.splice(index, 1)
    },
    getImage (fileObject) {
      console.log(fileObject)
      
      this.files.push({
        'files_id' : fileObject.files_id,
        'files_repository_id': fileObject.files_repository_id,
        'file_image_url': fileObject.file_image_url,
        'is_default':0
      })
    },
    removeImage (fileObject) {
      // console.log('fileObject', fileObject)
       console.log('fileObject', fileObject.upload.data.data)
      // console.log('fileObject', typeof fileObject.upload.data.data.cdn+fileObject.upload.data.data.files[0].file_path)
      
      this.files = this.files.filter((ele) => ele.file_image_url !== fileObject.upload.data.data.cdn+fileObject.upload.data.data.files[0].file_path)
    //  console.log('this.files', this.files)
    },
    createNewInventory (newObject) {
      this.inventoryList.unshift(newObject)
    },
  
    async fetchingAssetsCategory (payload = null) {
      
      try {
        this.$vs.loading({
          text:'Please wait...'
        })
        const customer_id = this.$store.getters.customerId

        const responseCategory = await fetchingAssetsCategoryApi(customer_id, payload)
        // 
        // 
        this.categoryList = responseCategory.data.data.assets_category_list

        return true 
      } catch (error) {
        
      } finally {
        this.$vs.loading.close()
      }
    },
    async fetchingAssetsInventoryName (payload = null) {
      
      try {
        this.$vs.loading({
          text:'Please wait...'
        })
        const customer_id = this.$store.getters.customerId

        const responseCategory = await fetchingAssetsInventoryName(customer_id, payload)
        // 
        // 
        this.inventoryNameList = responseCategory.data.data.assets_category_list

        return true 
      } catch (error) {
        
      } finally {
        this.$vs.loading.close()
      }
    },

    async fetchingInventoryType () {
      try {
        this.$vs.loading({
          text:'Please wait...'
        })
        const customer_id = this.$store.getters.customerId

        const responseInventoryType = await inventoryListTypeAPI(customer_id, 1)

        
        this.inventoryTypeList = responseInventoryType.data.data.assets_list
        // 
        // 
        // this.categoryList = responseCategory.data.data.assets_category_list
      } catch (error) {
        
      } finally {
        this.$vs.loading.close()
      }
    },
    checkingNonRemovable () {
      return JSON.stringify(this.non_removable_inventory_list) === JSON.stringify(this.old_non_removable_inventory_list)
    },
    selectDefaultImage (index) {
      this.files.forEach((ele, eachIndex) => {
        if (index !== eachIndex) {
          ele.is_default = 0

        }
      })
    },
    checkingDefaultValue () {

      if (!this.files.length) return true
      const fileDefault =  this.files.filter(eachImage => {
        return eachImage.is_default == '1'
      })

      if (fileDefault.length) {
        return true
      } else {
        return false
      }
      
      
    }

  }
  
}   